import template from './assignation.html';
import controller from './assignation.controller';

const assignationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default assignationComponent;
